<ng-container *transloco="let t; prefix: 'orders.customerConfiguration'">
  @if (customer(); as company) {
    <mat-card class="customer-summary" appearance="outlined">
      <mat-card-content class="customer-summary-content">
        <span class="customer-summary-name headline-small-emphasized">{{ company.ragioneSociale }}</span>
        <div class="customer-summary-field">
          <span class="body-large-emphasized">{{ t('taxCode') }}</span>
          <span class="body-large">{{ company.codiceFiscale || '—' }}</span>
        </div>
        <div class="customer-summary-field">
          <span class="body-large-emphasized">{{ t('vatNumber') }}</span>
          <span class="body-large">{{ company.partitaIva || '—' }}</span>
        </div>
      </mat-card-content>
    </mat-card>

    <div class="zones-heading">
      <span class="title-medium-emphasized">{{ t('zonesTitle') }}</span>
      <a matButton [routerLink]="['/new-order-proposal/configure-customer']" [queryParams]="{ id: proposalId }">{{ t('backToDestinations') }}</a>
    </div>

    <form class="zones-form" [formGroup]="form" (ngSubmit)="continue()">
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{ t('oilZone') }}</mat-label>
        <mat-select formControlName="oil" [placeholder]="t('selectZone')">
          <mat-option [value]="null">{{ t('noZone') }}</mat-option>
          @for (zone of oilZones; track zone.value) {
            <mat-option [value]="zone.value">{{ zone.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{ t('nonOilZone') }}</mat-label>
        <mat-select formControlName="nonOil" [placeholder]="t('selectZone')">
          <mat-option [value]="null">{{ t('noZone') }}</mat-option>
          @for (zone of nonOilZones; track zone.value) {
            <mat-option [value]="zone.value">{{ zone.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <div class="zones-actions">
        <button matButton="filled" type="submit" [disabled]="!configuration.destinationForConfiguration() || (!form.controls.oil.value && !form.controls.nonOil.value)">{{ t('continue') }}</button>
      </div>
    </form>
  } @else {
    <div class="zones-state">
      <span class="body-large">{{ t('missingCustomer') }}</span>
      <a matButton="outlined" [routerLink]="['/new-order-proposal/new-customer']" [queryParams]="{ id: proposalId }">{{ t('backToSearch') }}</a>
    </div>
  }
</ng-container>
